import {toast} from "react-toastify";

const toastSuccess = (message = "") =>{
    toast(message,{
        className: 'toast-background toast-success',
        bodyClassName: "toast-font toast-success",
        progressClassName: 'toast-loader toast-success'
    });
}

const toastError = (message = "") =>{
    toast(message,{
        autoClose: 10000,
        className: 'toast-background toast-error',
        bodyClassName: "toast-font toast-error",
        progressClassName: 'toast-loader toast-error'
    });
}

export {
    toastSuccess,
    toastError
}